import { generalTranslation } from './global.constants';

export enum PaymentStatus {
	None = 'None',
	AwaitingFunds = 'AwaitingFunds',
	AwaitingAuthorization = 'AwaitingAuthorization',
	AwaitingAltshulerAuthorization = 'AwaitingAltshulerAuthorization',
	Deleted = 'Deleted',
	Approved = 'Approved',
	Completed = 'Completed',
	Failed = 'Failed',
	Rejected = 'Rejected',
	Pending = 'Pending',
}

export const PaymentStatusHebrew = {
	AwaitingFunds: generalTranslation['AwaitingFunds'],
	AwaitingAuthorization: generalTranslation['AwaitingAuthorization'],
	AwaitingAltshulerAuthorization: generalTranslation['AwaitingAltshulerAuthorization'],
	Deleted: generalTranslation['Deleted'],
	Approved: generalTranslation['Approved'],
	Completed: generalTranslation['Completed'],
	Failed: generalTranslation['Failed'],
	Rejected: generalTranslation['Rejected'],
};
